import { useEffect, useState } from "react";
import type { DeviceCapability } from "./sceneTypes";

const defaultCapability: DeviceCapability = {
  isTouch: false,
  prefersReducedMotion: false,
  hardwareConcurrency: 4,
  deviceMemory: 8,
  viewportWidth: 1440
};

function readCapability(): DeviceCapability {
  if (typeof window === "undefined") {
    return defaultCapability;
  }

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  return {
    isTouch: window.matchMedia("(pointer: coarse)").matches,
    prefersReducedMotion,
    hardwareConcurrency: navigator.hardwareConcurrency || 4,
    deviceMemory: "deviceMemory" in navigator ? Number(navigator.deviceMemory) : null,
    viewportWidth: window.innerWidth
  };
}

export function useDeviceCapability() {
  const [capability, setCapability] = useState<DeviceCapability>(defaultCapability);

  useEffect(() => {
    setCapability(readCapability());
    const onResize = () => setCapability(readCapability());

    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return capability;
}
